export default __webpack_public_path__ + "static/bg-doctor-eeab22030a6243bde2be4c247a0bcd0e.webp";